export default __webpack_public_path__ + "static/media/Image5.59058382.jpeg";